import FileUpload from '@modules/husleie-framework/src/types/FileUpload.entity';

const enum SignerStatusEnum {
  PENDING = 'pending',
  SIGNED = 'signed',
  DECLINED = 'declined',
}

type SignerStatus = SignerStatusEnum.PENDING | SignerStatusEnum.SIGNED | SignerStatusEnum.DECLINED;

const enum SignerTypeEnum {
  LANDLORD = 'landlord',
  TENANT = 'tenant',
  COTENANT = 'cotenant',
}

type SignerType = SignerTypeEnum.LANDLORD | SignerTypeEnum.TENANT | SignerTypeEnum.COTENANT;

const enum SignMethodEnum {
  DIGITAL = 'token',
  OFFLINE = 'offline',
  NOR_BANK_ID = 'bankid-no',
  NECT = 'verified_digital_signing',
}
type SignMethodType =
  | SignMethodEnum.DIGITAL
  | SignMethodEnum.OFFLINE
  | SignMethodEnum.NOR_BANK_ID
  | SignMethodEnum.NECT;

type SignatureData = { [key: string]: any }[];

interface Signature {
  pointData?: SignatureData;
  imageDataURL?: string;
  image?: FileUpload;
}

const enum SigningStatusEnum {
  OPEN = 'open',
  SIGNING = 'signing',
  SIGNING_TENANT = 'signing_tenant',
  SIGNING_LANDLORD = 'signing_landlord',
  SIGNED = 'signed',
  CANCELED = 'canceled',
  // Extra values for security deposit.
  DRAFT = 'draft', // Tenant has not done the KYC yet (basicly SIGNING_TENANT)
  INITIATED = 'initiated', // Tenant has done the KYC (basicly SIGNING_TENANT/LANDLORD)
  ACTIVE = 'active', // Both tenant and landlord has signed
}

type SigningStatus =
  | SigningStatusEnum.OPEN
  | SigningStatusEnum.SIGNING
  | SigningStatusEnum.SIGNING_TENANT
  | SigningStatusEnum.SIGNING_LANDLORD
  | SigningStatusEnum.SIGNED
  | SigningStatusEnum.DRAFT
  | SigningStatusEnum.INITIATED
  | SigningStatusEnum.ACTIVE;

interface Signer {
  uuid: string;
  fullName?: string;
  signature?: Signature;
  type: SignerType;
  status: SignerStatus;
  uploadToken?: string;
  signatureFileToken?: string;
  redirectURL?: string;
}

interface NectCreateSigningData {
  method: string;
  representative: string;
  callback: string;
  token: string;
  signers: any;
}

interface NectSigner {
  id: string;
  type: SignerType;
  status: SigningStatus;
}

interface SignersStatus {
  landlord?: SignerStatus;
  tenant?: SignerStatus;
}

export {
  Signer,
  Signature,
  SignerStatus,
  SignerStatusEnum,
  SignerType,
  SignerTypeEnum,
  SignMethodType,
  SignMethodEnum,
  SignatureData,
  SigningStatus,
  SigningStatusEnum,
  NectCreateSigningData,
  NectSigner,
  SignersStatus,
};
